// src/apiService.js

import axiosClient from './axiosClient'; // Import the Axios client

// Function to fetch airport
const getAirports = async () => {
    try {
        const response = await axiosClient.get('/airport'); // API call
        return response.data; // Return the data from the response
    } catch (error) {
        console.error('Error fetching airport:', error);
        throw error; // Rethrow the error for further handling
    }
};

const getActiveAirports = async () => {
    try {
        const response = await axiosClient.get('/airport/active'); // API call
        return response.data; // Return the data from the response
    } catch (error) {
        console.error('Error fetching airport:', error);
        throw error; // Rethrow the error for further handling
    }
};

const getAirportDetail = async (id) => {
    try {
        const response = await axiosClient.get(`/airport/${id}`); // API call
        return response.data; // Return the data from the response
    } catch (error) {
        console.error('Error fetching airport:', error);
        throw error; // Rethrow the error for further handling
    }
};

const createAirport = async (body) => {
    try {

        const response = await axiosClient.post('/airport', body, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data; // Return API response
    } catch (error) {
        console.error('Error creating airport:', error);
        throw error; // Rethrow error for handling in the component
    }
};

// DELETE airport by ID
const deleteAirport = async (id) => {
    try {
        const response = await axiosClient.delete(`/airport/${id}`);
        return response.data; // Return the response data
    } catch (error) {
        console.error('Error deleting airport:', error);
        throw error; // Rethrow error for handling in the component
    }
};

// PATCH airport by ID
const updateAirport = async (id, body) => {
    try {
        const response = await axiosClient.patch(`/airport/${id}`, body, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data; // Return the response data
    } catch (error) {
        console.error('Error updating airport:', error);
        throw error; // Rethrow error for handling in the component
    }
};

// Update user by ID
export const toggleAirportStatus = async (userData) => {
    try {
        const response = await axiosClient.patch(`/airport/toggle-status`, userData, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error updating airport:", error.response?.data || error.message);
        throw error;
    }
};

// Export the function
export { getAirports, deleteAirport, createAirport, updateAirport, getAirportDetail, getActiveAirports };
